import { Text, Title } from "@clipboard-health/ui-components";
import { Link, Stack } from "@mui/material";
import { Li, Ul } from "@src/appV2/lib/Lists";
import { useGetQualificationsForRequirement } from "@src/appV2/redesign/Documents/useGetQualificationsForRequirement";
import { useZendeskArticle } from "@src/appV2/Zendesk/useZendeskArticle";

import { useSkillsAssessmentFeatureFlags } from "../../api/useSkillsAssessmentFeatureFlags";
import { type SkillsAssessment } from "../../types";

interface Props {
  assessment: SkillsAssessment;
  qualification?: string;
}
export function SkillsAssessmentVideoStartFromMyAccountScheduledStep(props: Props) {
  const { assessment, qualification } = props;
  const { qualificationDisplayLabels } = useGetQualificationsForRequirement([qualification ?? ""]);
  const qualificationDisplayLabel = qualificationDisplayLabels[0];

  const { skillsAssessmentConfig } = useSkillsAssessmentFeatureFlags();
  const { openArticle } = useZendeskArticle();

  return (
    <Stack spacing={4}>
      <Title component="h1">Continue to take the required assessment.</Title>
      <Ul>
        <Li>
          <Text sx={{ lineHeight: "24px" }}>
            You&apos;ll answer questions pertaining to your knowledge and experience as a{" "}
            {qualificationDisplayLabel} over video.
          </Text>
        </Li>
        <Li>
          <Text sx={{ lineHeight: "24px" }}>
            The assessment takes about{" "}
            {assessment.attributes.videoAsk.estimatedTimeToCompleteInMinutes} minutes.
          </Text>
        </Li>
        <Li>
          <Text sx={{ lineHeight: "24px" }}>
            Tap{" "}
            <Link
              onClick={async () => {
                await openArticle(skillsAssessmentConfig.supportArticleLink);
              }}
            >
              here
            </Link>{" "}
            for additional details.
          </Text>
        </Li>
      </Ul>
    </Stack>
  );
}
